import React from 'react';

export function Header({title}) {
  return <header className="rws-header">{title}</header>;
}
